import React from 'react';

interface ErrorFallbackProps {
  /** Human-readable name of the section that failed (e.g. "To-Do list") */
  title?: string;
}

/**
 * Reusable error fallback for ErrorBoundary `fallback` props.
 * Shows a friendly message with "Try Again" (reloads the page section)
 * and "Go Home" actions so users can self-recover without a full refresh.
 */
const ErrorFallback: React.FC<ErrorFallbackProps> = ({ title = 'this section' }) => (
  <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
    <div className="text-4xl mb-3" aria-hidden>⚠️</div>
    <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">
      Failed to load {title}
    </h2>
    <p className="text-sm text-gray-500 dark:text-gray-400 mb-4 max-w-md">
      Something went wrong. You can try reloading or go back to the dashboard.
    </p>
    <div className="flex gap-3">
      <button
        onClick={() => window.location.reload()}
        className="px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors"
        style={{ backgroundColor: 'var(--c1)', }}
      >
        Try Again
      </button>
      <button
        onClick={() => { window.location.href = '/'; }}
        className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-lg transition-colors"
      >
        Go Home
      </button>
    </div>
  </div>
);

export default ErrorFallback;
